<div class="map-container">
    <div class="map-frame">
      <div #map id="map"></div>
    </div>
  </div>